import React from "react";
import Table from "../../../../../../common/element/Table";
import moment from "moment/moment";
const { Tr, Th, Td, THead, TBody } = Table;
const DataList = ({ data, handleSort, getAllinvitedData }) => {
  return (
    <React.Fragment>
      <div className="overflow-hidden border rounded-lg border-gray-200">
        <Table>
          <THead>
            <Tr>
              <Th>Client</Th>
              <Th>Provider</Th>
              <Th>Provider type</Th>
              <Th>Documents name</Th>
              <Th>Status</Th>
              <Th onClick={(e) => handleSort(e, "approval_date")}>
                <span className="flex items-center gap-1">
                  Approval date
                  <svg
                    className={`transform ${
                      getAllinvitedData.sort === "approval_date" &&
                      getAllinvitedData.order === "asc"
                        ? "rotate-180"
                        : ""
                    }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      stroke-width="1.333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              <Th onClick={(e) => handleSort(e, "expiry_date")}>
                <span className="flex items-center gap-1">
                  Expiry date
                  <svg
                    className={`transform ${
                      getAllinvitedData.sort === "expiry_date" &&
                      getAllinvitedData.order === "asc"
                        ? "rotate-180"
                        : ""
                    }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      stroke-width="1.333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Th>
            </Tr>
          </THead>
          <TBody>
            {data?.DocsReport?.length > 0 &&
              data?.DocsReport?.map((item, index) => {
                return (
                  <Tr key={index}>
                    <Td>{item?.client_trading_name}</Td>
                    <Td>{item?.provider_trading_name}</Td>
                    <Td>{item?.provider_type_name}</Td>
                    <Td>{item?.document_name}</Td>
                    <Td>
                      <span
                        className={
                          item?.status == "Approved"
                            ? "badge bg-success-50 text-success-700 py-0.5 px-2 rounded-lg font-medium"
                            :  item?.status === "	Action required"
                            ? "badge bg-error-100 text-error-700 py-0.5 px-2 rounded-lg font-medium"
                            : item?.status === "Awaiting review"
                            ? "badge bg-blue-50 text-blue-800 py-0.5 px-2 rounded-lg font-normal"
                            : 
                             " badge bg-error-100 text-error-700 py-0.5 px-2 rounded-lg font-medium"
                        }
                        // Action required
                      >
                        {item?.status}
                      </span>
                    </Td>
                    <Td>
                      {item?.approval_date
                        ? moment(item?.approval_date).format("DD/MM/YYYY")
                        : "-"}
                    </Td>
                    <Td>
                      {item?.expiry_date
                        ? moment(item?.expiry_date).format("DD/MM/YYYY")
                        : "-"}
                    </Td>
                  </Tr>
                );
              })}
          </TBody>
        </Table>
      </div>
    </React.Fragment>
  );
};
export default DataList;
